import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EmailConfigurationRouter } from './email-configuration.router';
import { reducers } from './state/email-configuration.selectors';

@NgModule({
  imports: [
    EmailConfigurationRouter,
    StoreModule.forFeature('emailConfiguration', reducers)
  ],
  declarations: []
})
export class EmailConfigurationScreenModule { }